import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ITestsState } from '@ispm/core/interfaces/genomics-state.interface';

export const getTestsState = createFeatureSelector<ITestsState>('tests');

export const getTestBarState = createSelector(getTestsState, state => state.testBar);

export const getTestButtonConfirmButtonEnabledState = createSelector(getTestBarState,
  (state) => state.confirmButtonEnabled && state.confirmButtonAvailable);

export const getTestButtonConfirmTooltipState = createSelector(getTestBarState,
  (state) => state.confirmButtonTooltip);
